"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.processGroups = exports.camelize = exports.processTemplateStrings = exports.getEnvVals = exports.generateUID = exports.customMerge = exports.YEAR_1 = exports.HOURS_24 = exports.HOURS_4 = exports.fixMetadata = exports.clean = exports.toDataAttrs = exports.prefixKeys = exports.toSearch = exports.toParams = exports.arrayParser = exports.stripES6 = exports.es6Regex = exports.thisRegex = exports.template = exports.getFromObj = void 0;
var deepmerge_1 = __importDefault(require("deepmerge"));
/**
 * @param {String} path
 * @param {Object} obj Object to find the property in
 * @param {String} fb Fallback string when not found
 * @return {*|String} whatever the value from the nested key path is or the default string '${path}'.
 * @description Returns the value of an object via the path as a string
 *
 * @example
 * let result = getFromObj('hello.foo', {
 *  hello: {
 *    foo: 'bar'
 *  }
 * });
 *
 * result == 'bar';
 */
var getFromObj = function (path, obj) {
    if (obj === void 0) { obj = {}; }
    return path && path.split('.').reduce(function (res, key) { return res[key] != null ? res[key] : path; }, obj);
};
exports.getFromObj = getFromObj;
/**
 * @param {String} tmpl the string template
 * @param {Object} map Key/Value pairs to process the string against
 * @param {String} fallback they string fallback when the value is missing.
 * @return {*|String} whatever the value from the nested key path is or the default string '${path}'.
 * @description Processes a string formatted like an ES6 template against an object
 *
 * @example
 * let result = template('I am a string literal formatted ${message.label}.', {
 *  message: {
 *    label: 'to look like an ES6 template'
 *  }
 * });
 *
 * result == 'I am a string literal formatted to look like an ES6 template.';
 */
var template = function (tmpl, map) {
    var context = Object.assign({ this: map }, map);
    return exports.getFromObj(exports.stripES6(tmpl, context), context);
};
exports.template = template;
exports.thisRegex = /^this\./;
exports.es6Regex = /\$\{.+?}/g;
/**
 * @param {String} expr The es6 expression
 * @param {Options|Object} context the context object to find values for tokens.
 * @return {String} The cleaned sxpression without the ${}.
 * @description removes the ${} wrapping from an es6 template literal expression.
 */
var stripES6 = function (expr, context) {
    return expr && expr.replace(exports.es6Regex, function (match) {
        return exports.getFromObj(match.substr(2, match.length - 3).trim(), context);
    }).replace(exports.thisRegex, '');
};
exports.stripES6 = stripES6;
/**
 * @function arrayParser
 * @param {Object} val the value to parse
 * @param {String} key the name of the value to parse
 * @param {Object} params all of the parameters that have been parsed so far.
 * @return {Boolean} returns the currently parsed value.
 * @description In the event that the search string has multiple values with the same key
 * it will convert that into an array of those values for the given key.
 *
 * While there is no defined standard in [RFC 3986 Section 3.4]{@link https://tools.ietf.org/html/rfc3986#section-3.4},
 * most web frameworks accept and serialize them in the following manner as outlined
 * in [MSDN]{@link https://docs.microsoft.com/en-us/previous-versions/iis/6.0-sdk/ms524784(v=vs.90)}
 *
 * @example @lang js
 * window.location.search = '?values=foo&values=bar&values=hello&values=world';
 * const params = toParams(window.location.search, {});
 * console.log(params) // {values: ["foo","bar","hello", "world"]}
 *
 * @example @lang js
 * window.location.search = '?values=1&values=2&values=3&values=5&values=7';
 * const params = toParams(window.location.search, {
 *     values: parseInt
 * });
 * console.log(params) // {values: [1, 2, 3, 5, 7]}
 *
 * @example @lang js
 * window.location.search = '?answer=42';
 * const params = toParams(window.location.search, {
 *     answer: parseInt
 * });
 * console.log(params) // {answer: 42}
 */
var arrayParser = function (val, key, params) {
    var current = params[key];
    if (current) {
        if (!Array.isArray(current)) {
            current = [current];
        }
        current.push(val);
    }
    else {
        current = val;
    }
    return current;
};
exports.arrayParser = arrayParser;
/**
 * @function toParams
 * @param {String} str
 * @param {Object} options custom parser functions based on the key name
 * @return {Object} seach params as an object
 * @description Converts URL parameters to a Object collection of key/value pairs
 * Decodes encoded url characters to back to normal strings.
 * @example <caption>convert query string to object:</caption>
 * import {toParams} from '@ornery/web-components';
 * let paramsObject = toParams('?foo=bar&hello=world&hello=array&unsafe=I%20am%20an%20unsafe%20string');
 *
 * console.log(paramsObject) // { foo: 'bar', hello: ['world', 'array'], unsafe: 'I am an unsafe string'}
 * @example <caption>pass an optional parser object</caption>
 * import {toParams} from '@ornery/web-components';
 * let paramsObject = toParams('?intvals=1&intvals=2&intvals=3', {
 *     intvals: parseInt
 * });
 *
 * console.log(paramsObject) // { intvals: [ 1, 2, 3 ] }
 * @example <caption>without psassing an optional parser object</caption>
 * import {toParams} from '@ornery/web-components';
 * let paramsObject = toParams('?intvals=1&intvals=2&intvals=3');
 *
 * console.log(paramsObject) // { intvals: [ "1", "2", "3" ] }
 */
var toParams = function (str, options) {
    if (options === void 0) { options = {}; }
    var parts = str.split('?');
    var queryString = parts[1] || '';
    var params = {};
    queryString.split(options.paramDelimiter || "&").forEach(function (val) {
        var innerParts = val.split('=');
        if (innerParts.length !== 2)
            return;
        var paramKey = decodeURIComponent(innerParts[0]);
        var paramVal = decodeURIComponent(innerParts[1]);
        var parser = options[paramKey] || (function () { return paramVal; });
        params[paramKey] = exports.arrayParser(parser(paramVal, paramKey, params), paramKey, params);
    });
    return params;
};
exports.toParams = toParams;
/**
 *
 * @param {Object} options
 * @param {String} base
 * @return {String} the object represented as a query string.
 * @description Converts an Object of String/Value pairs to a query string for URL parameters prepended with the "base" character.
 * Encodes unsafe url characters to url safe encodings.
 * @example <caption>convert object to query string</caption>
 *
 * import {toSearch} from '@ornery/web-components';
 * let queryString = toSearch({
 *  foo: 'bar',
 *  hello: ['world', 'array'],
 *  unsafe: 'I am an unsafe string'
 *
 * }, '#');
 *
 * queryString == '#?foo=bar&hello=world&hello=array&unsafe=I%20am%20an%20unsafe%20string';
 */
var toSearch = function (options) {
    var filtered = Object.entries(options).filter(function (ent) { return !!ent[1]; });
    var uri = "?" + filtered.map(function (ent) {
        if (Array.isArray(ent[1])) {
            return ent[1].map(function (val) { return [encodeURIComponent(ent[0]), encodeURIComponent(val)].join('='); }).join('&');
        }
        else {
            ent[0] = encodeURIComponent(ent[0]);
            ent[1] = encodeURIComponent(ent[1]);
            return ent.join('=');
        }
    }).join('&');
    return uri;
};
exports.toSearch = toSearch;
/**
 *
 * @param {Object} obj
 * @param {String} prefix
 * @return {Object} The new object with transformed keys.
 * @description Convenience method that converts the keys of an object to have a prefix.
 * This is faster than stringification.
 *
 * @example
 * import {prefixKeys} from '@ornery/web-components';
 * let newObj = prefixKeys({
 *  foo: 'bar',
 *  hello: ['world', 'array'],
 *  unsafe: 'I am an unsafe string'
 *
 * }, 'zoo-');
 *
 * newObj == {
 *   'zoo-foo': 'bar',
 *   'zoo-hello': ['world', 'array']',
 *   'zoo-unsafe': 'I am an unsafe string'
 * };
 */
var prefixKeys = function (obj, prefix) {
    var keys = [];
    if (Array.isArray(obj)) {
        // @ts-ignore
        keys = obj.map(function (val, i) { return i; });
    }
    else {
        keys = Object.keys(obj);
    }
    return Object.assign.apply(Object, __spreadArray([{}], keys.map(function (key) {
        var _a;
        return (_a = {}, _a[prefix + key] = obj[key], _a);
    })));
};
exports.prefixKeys = prefixKeys;
/**
 *
 * @param {Object} obj
 * @param {Boolean} stringify wether or not to stringify the values for each key.
 * @return {Object} The new object with transformed keys.
 * @description Convenience method that wraps prefixKeys with 'data-' for easier
 * property spreading within other frameworks such as react.
 * This is preferrable over stringifying objects as parsing json is slow in the browser
 * @example <caption>React example</caption>
 * const stringTestData = {
 *  color: "black and white",
 *  animal: "panda"
 * };
 *
 * const MyComponent = (props) => {
 *   const dataAttrs = toDataAttrs(stringTestData);
 *   return (<div>
 *     <div>
 *       <i18n-message
 *         data-key="tokenized.message"
 *         {...dataAttrs}/>
 *     </div>
 *     <div>
 *       <i18n-message
 *         data-id="tokenized.message"
 *         {...dataAttrs}
 *         data-color="red"/>
 *     </div>
 *   </div>);
 * };

 const dataAttrs = toDataAttrs(stringTestData);
 */
var toDataAttrs = function (obj) {
    return exports.prefixKeys(obj, 'data-');
};
exports.toDataAttrs = toDataAttrs;
var clean = function (obj) {
    if (!obj)
        return null;
    if (Array.isArray(obj)) {
        obj = obj.filter(function (v) { return v !== undefined; });
    }
    var entries = Object.entries(obj);
    if (!entries.length) {
        return obj;
    }
    else {
        entries.forEach(function (_a) {
            var key = _a[0], val = _a[1];
            try {
                if (val === undefined) {
                    try {
                        delete obj[key];
                    }
                    catch (ex) {
                        obj[key] = null;
                    }
                }
                else if (typeof (val) !== "string") {
                    var newVal = exports.clean(val);
                    if (newVal) {
                        obj[key] = newVal;
                    }
                    else if (key !== "children") {
                        try {
                            delete obj[key];
                        }
                        catch (ex) {
                            obj[key] = null;
                        }
                    }
                }
            }
            catch (ex) {
                console.log(ex.message);
            }
        });
    }
    return obj;
};
exports.clean = clean;
var fixMetadata = function (section) {
    // TECH DEBT: m should never be null, but we still have to check in the conditional?
    if (section.meta) {
        var thumbnail = section.meta.find(function (m) { return m && m.name === "thumbnail"; });
        if (thumbnail) {
            section.thumbnail = thumbnail.href;
        }
    }
    if (section.children) {
        section.children = section.children.map(exports.fixMetadata);
    }
    if (!section.target) {
        var isExternal = ((section.topicId && section.topicId.indexOf("EXTERNAL_LINK_ID__") > -1) ||
            (section.sys && section.sys.uuid && section.sys.uuid.indexOf("EXTERNAL_LINK_ID__") > -1) ||
            (section.href && (section.href.startsWith("http") || section.href.startsWith("mailto:"))));
        section.target = isExternal ? '_blank' : '_self';
    }
    return section;
};
exports.fixMetadata = fixMetadata;
exports.HOURS_4 = 3600 * 4;
exports.HOURS_24 = exports.HOURS_4 * 6;
exports.YEAR_1 = exports.HOURS_24 * 365;
var customMerge = function () { return function (a, b) { return b == null ? a : deepmerge_1.default(a, b, { customMerge: exports.customMerge }); }; };
exports.customMerge = customMerge;
var getPart = function () { return ("000" + ((Math.random() * 46656) | 0).toString(36)).slice(-3); };
var generateUID = function () { return "" + getPart() + getPart(); };
exports.generateUID = generateUID;
var getEnvVals = function (runtimeConfig, key, ezdConfigEnv) {
    var tenantVals = [];
    if (Array.isArray(runtimeConfig[key])) {
        tenantVals = runtimeConfig[key];
    }
    else {
        if (runtimeConfig[key] && Array.isArray(runtimeConfig[key].all)) {
            tenantVals = runtimeConfig[key].all;
        }
        if (runtimeConfig[key] && Array.isArray(runtimeConfig[key][ezdConfigEnv])) {
            tenantVals = runtimeConfig[key][ezdConfigEnv].concat(runtimeConfig[key][ezdConfigEnv]);
        }
    }
    return tenantVals;
};
exports.getEnvVals = getEnvVals;
var processTemplateStrings = function (obj, context) {
    if (Array.isArray(obj)) {
        return obj.map(function (v) { return exports.processTemplateStrings(v, context); });
    }
    if (typeof obj === "string") {
        return exports.template(obj, context);
    }
    return Object.entries(obj).reduce(function (acc, _a) {
        var key = _a[0], val = _a[1];
        if (val && typeof val === "string") {
            acc[key] = exports.template(val, context);
        }
        else if (val && typeof val === "object") {
            acc[key] = exports.processTemplateStrings(val, context);
        }
        else if (Array.isArray(val)) {
            acc[key] = [];
            val.forEach(function (sv) {
                if (sv && typeof sv === "string") {
                    acc[key].push(exports.template(sv, context));
                }
                else {
                    acc[key].push(exports.processTemplateStrings(sv, context));
                }
            });
        }
        return acc;
    }, {});
};
exports.processTemplateStrings = processTemplateStrings;
var camReg = /[_.-](\w|$)/g;
var camelize = function (str) {
    if (str === void 0) { str = ""; }
    return str.replace(camReg, function (_, x) { return x.toUpperCase(); });
};
exports.camelize = camelize;
var processGroups = function (groups, client) { return __awaiter(void 0, void 0, void 0, function () {
    var groupsArray;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                groupsArray = Object.entries(groups).map(function (_a) {
                    var key = _a[0], group = _a[1];
                    group.children = group.children.map(function (item) { return client.content.getContent(item.href).then(function (data) {
                        if (!data.error) {
                            Object.assign(item, data);
                            return exports.fixMetadata(item);
                        }
                        else {
                            return null;
                        }
                    }); });
                    group.id = exports.camelize(key);
                    return group;
                });
                return [4 /*yield*/, Promise.all(groupsArray.map(function (group) { return Promise.all(group.children).then(function (data) {
                        data.id = group.id;
                        return data;
                    }); })).then(function (data) {
                        return data.reduce(function (acc, item) {
                            if (item && item.length)
                                acc[item.id] = Array.from(item);
                            return acc;
                        }, {});
                    })];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
exports.processGroups = processGroups;
